/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Rule} from "../../models/rule";
import {RulesService} from "../../services/rules.service";
import {Component, Input, ViewChild} from "@angular/core";
import {Router} from "@angular/router";
import { ERROR_DIALOG_TITLE, SimpleSuccessErrorDialogComponent } from "../simple-success-error-dialog-box/simple-success-error-dialog-box.component";

declare var $: any;

const ID = "step5_reviewAndFinish";
const ID_VALIDATE_SUCCESS = "validateSuccess";
const ID_VALIDATE_ERROR = "validateError";
const ID_VALIDATE_WARNING = "validateWarning";

@Component({
  selector: 'app-rule-editor-step-review-and-finish',
  templateUrl: './rule-editor-step-review-and-finish.component.html'
})
export class RuleEditorStepReviewAndFinishComponent {
  
  //Main DIV ID, referenced here so it can be used in the .html as well as the JQuery stuff internal to this component
  mId = ID;
  
  @Input()    //Rule being edited
  mRule: Rule;

  
  mValidateWarningMessage: string = null;
  mValidateErrorMessage: string = null;
  mIsRuleValidated = false;

    /** Reference to the SimpleSuccessErrorDialog used to display error */
    @ViewChild('successErrorDialog') 
    simpleSuccessErrorDialogComponent: SimpleSuccessErrorDialogComponent;

  constructor(
    private mRouter: Router,
    private mRulesService: RulesService
  ) {}
  
  
  setVisible(visible: boolean): void {
    visible? $("#" + this.mId).show() : $("#" + this.mId).hide();
  }


  validateRuleClicked(): void {
    console.log("validateRuleClicked()");
    this._validateRule();
  }

  private async _validateRule(): Promise<void> {
    this.hideValidateMessages();

    try {
      await this.mRulesService.validateRule(this.mRule);
      this.showValidateSuccessMessage();
    } catch (error) {
      if (error != null) {
        this.mValidateErrorMessage = error.error;
        this.showValidateErrorMessage();
      }
    }
  }

  private showValidateSuccessMessage(): void {
    this.mIsRuleValidated = true;
    $("#" + ID_VALIDATE_SUCCESS).show();
  }

  private showValidateErrorMessage(): void {
    $("#" + ID_VALIDATE_ERROR).show();
  }

  private showValidateWarningMessage(): void {
    $("#" + ID_VALIDATE_WARNING).show();
  }

  private hideValidateMessages(): void {
    this.mIsRuleValidated = false;
    $("#" + ID_VALIDATE_SUCCESS).hide();
    $("#" + ID_VALIDATE_ERROR).hide();
    $("#" + ID_VALIDATE_WARNING).hide();
  }

  finishClicked(): void {
    console.log("finishClicked()");
    this._finishClicked();
  }

  private async _finishClicked(): Promise<void> {
    try {
      //Depending on if the Rule is new or not, either create it or update it
      if (this.mRule.id == null) {
        await this.mRulesService
          .createRule(this.mRule);
      } else {
        await this.mRulesService
          .updateRule(this.mRule);
      }

      //If it made it this far, the Rule was successfully created/updated... Return the User to the main Rules Page
      this.mRouter.navigateByUrl(`/rules`);
    } catch (error) {
      this.handleError(error);
    }
  }


  /*
   * Generic Error Handling method
   * Displays error in an alert
   */
  private handleError(error: any): void {
    console.error("handleError() - Error: " + error);
    if (error?.error != null) {
      this.simpleSuccessErrorDialogComponent.showErrorDialog(ERROR_DIALOG_TITLE, error.error);
    }
    else if (error != null) {
      const response: Response = error;
      alert(response.text());
    }
  }

}
